import { useFieldState as fieldState } from 'informed';

export default function useFieldState<T extends any>(field: string): { value: T } {
  return fieldState(field) as unknown as { value: T };
}
